var React = require('react');

function BsmLogo (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none"},[React.createElement("path",{"fill":"#315db6","d":"M0 0 l832 0 0 1141 -832 0z","key":0}),React.createElement("path",{"fill":"#ffffff","d":"M408 16 l0 1109 -392 0z M424 16 l0 1109 392 0z","key":1})]));
}

BsmLogo.defaultProps = {"viewBox":"0 0 832 1141"};

module.exports = BsmLogo;

BsmLogo.default = BsmLogo;
